export default __webpack_public_path__ + "static/media/3a5b2eecdcec2d92ad4c08b983d7b92c.png";